import type { ChordQualityKey } from "@/lib/music/chord-catalog";
import type { ChordQuality } from "./types";

const KEY_TO_LAYOUT: Partial<Record<ChordQualityKey, ChordQuality>> = {
  major: "maj",
  minor: "min",
  diminished: "dim",
  augmented: "aug",
  "7": "7",
  maj7: "maj7",
  m7: "m7",
  m7b5: "m7b5",
  dim7: "dim7",
};

/**
 * Map the music-theoretic chord quality (used across the catalog and
 * exercise model) to the layout-side ChordQuality understood by
 * `placeChord`. Returns null for qualities that have no canonical
 * keyboard placement (sus chords).
 */
export function chordQualityToLayout(
  q: ChordQualityKey,
): ChordQuality | null {
  return KEY_TO_LAYOUT[q] ?? null;
}
